/**
 * "Estou dentro de uma linha de listagem?" (relato G1 da v1.2.0 · D-155 · DS-569).
 *
 * A `LinhaDaListagem` e o `LinkDaEntidade alvoDaLinha` dizem `true` aos filhos, e o
 * `LinkDaEntidade` comum lê isto para virar texto: dentro da linha, o nome de outro registro
 * não é link, porque o clique abre a linha. `Modal` e `Gaveta` dizem `false` de novo, porque
 * um diálogo é painel de detalhe, mesmo quando montado de dentro de uma linha.
 *
 * Arquivo à parte para `link-da-entidade.tsx` e `linha-da-listagem.tsx` não se importarem
 * em círculo.
 */
import { createContext, useContext } from 'react'

export const ContextoDaLinha = createContext(false)

export function useDentroDaLinha(): boolean {
  return useContext(ContextoDaLinha)
}
